/**
 * Process AWS Transcribe audioSegments into an array of timestamped sentences
 * @param {Array} audioSegments - Array of audioSegments from AWS Transcribe
 * @returns {Array} Array of sentences with the text, start_ts, end_ts, and items
 */
export const processAudioSegmentsIntoSentences = (audioSegments) => {
  if (!Array.isArray(audioSegments)) {
    return [];
  }

  return audioSegments.reduce((sentences, segment) => {
    if (!segment) {
      return sentences;
    }
    const start_ts = parseFloat(segment.start_time);
    const end_ts = parseFloat(segment.end_time);
    if (!Number.isFinite(start_ts) || !Number.isFinite(end_ts)) {
      return sentences;
    }
    sentences.push({
      end_ts,
      items: segment.items || [],
      start_ts,
      text: segment.transcript,
    });
    return sentences;
  }, []);
};

/**
 * Format timestamp in seconds to mm:ss or hh:mm:ss format
 * @param {number} seconds - Time in seconds
 * @returns {string} Formatted timestamp
 */
export const formatTimestamp = (seconds) => {
  if (!seconds && seconds !== 0) return '00:00';

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }

  return `${minutes}:${secs.toString().padStart(2, '0')}`;
};

/**
 * Helper to highlight matched text using mark tags
 * @param {string} text - The text to highlight
 * @param {string} query - The search query to highlight
 * @returns {Array} Array of text parts and mark elements
 */
export const highlightText = (text, query) => {
  if (!query) return text;

  const lowerText = text.toLowerCase();
  const lowerQuery = query.toLowerCase();
  const parts = [];
  let lastIndex = 0;
  let index = lowerText.indexOf(lowerQuery);

  while (index !== -1 && lowerQuery.length > 0) {
    if (index > lastIndex) {
      parts.push(text.slice(lastIndex, index));
    }
    parts.push(<mark key={index}>{text.slice(index, index + lowerQuery.length)}</mark>);
    lastIndex = index + lowerQuery.length;
    index = lowerText.indexOf(lowerQuery, lastIndex);
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts;
};
